import * as _ from 'lodash';
import { ImAttendanceRecord } from './../../../../shared/static-models/im-models/im-attendance-record.service';
// tslint:disable-next-line:max-line-length

angular
  .module('nv.support-overview')

  .component('studentAttendanceLogs', {
    template: require('./student-attendance-logs.html'),
    bindings: {
      attendanceRecords: '<',
      studentSupports: '<',
      toggleView: '&',
      support: '<',
    },
    controller(
      SupportAttendanceService,
      AttendanceRecord,
      StudentSupport,
      UtilitiesService,
      ImAttendanceRecord: ImAttendanceRecord,
    ) {
      this.$onInit = () => {
        // Load the toggleView callback, toggles between student/eventDate log summaries
        this.onToggle = this.toggleView();

        const studentSupportDefaultAttendanceData = _.reduce(
          this.studentSupports,
          (result, studentSupport: any) => {
            const {
              support: { supportId },
              student: { studentId },
            } = studentSupport;
            result[studentId] = {
              ABSENT: 0,
              LATE: 0,
              PRESENT: 0,
              total: 0,
              percentAbs: 0,
              percentPresAndLate: 0,
              percentLate: 0,
              percentPres: 0,
              studentId,
              studentSupportStatus: studentSupport.getFrontendStatus(),
              studentSupportStart: UtilitiesService.convertISODateToHumanDate(studentSupport.startsOn),
              supportId,
            };
            return result;
          },
          {},
        );

        const attendanceRecordsHashedBySupportId = ImAttendanceRecord.hashAttendanceRecordsBySupportId(
          this.attendanceRecords,
        );

        const attendanceRecordsForCurrentSupport = attendanceRecordsHashedBySupportId[this.support._id] || [];

        const attendanceSummariesForCurrentSupport = SupportAttendanceService.summarizeAttendanceData(
          attendanceRecordsForCurrentSupport,
          'studentId',
        );

        const buildAttendanceLogByStudent = (
          attendanceSummariesForCurrentSupport,
          studentSupportDefaultAttendanceData,
        ) => {
          const attendanceSummariesForCurrentSupportByStudentId = _.reduce(
            attendanceSummariesForCurrentSupport,
            (result, attendanceSummary: any) => {
              // only assign if the student on the roster has an attendance summary
              if (result[attendanceSummary.studentId]) {
                result[attendanceSummary.studentId] = _.assign(result[attendanceSummary.studentId], attendanceSummary);
              }
              return result;
            },
            studentSupportDefaultAttendanceData,
          );

          const recordsWithNamesMapped = _.map(attendanceSummariesForCurrentSupportByStudentId, (record: any) => {
            const lastFirst = _.result(
              this.studentSupports.find(studentSupport => record.studentId === studentSupport.student.studentId),
              'student.lastFirst',
            );
            return Object.assign({ lastFirst }, record);
          });

          const sorted = _.sortBy(recordsWithNamesMapped, 'lastFirst');
          return sorted;
        };

        this.recordsByStudentId = buildAttendanceLogByStudent(
          attendanceSummariesForCurrentSupport,
          studentSupportDefaultAttendanceData,
        );
      };
    },
  });
